<p-scroll-panel class="h-full">
  @let dokument = dokService.selectedDokument();
  @if (dokService.datasource.isLoading()) {
    <app-let-loading-indicator />
  }
  @if (dokument && !dokService.datasource.isLoading()) {
    <div class="detail-section-header">Dokumentegenskaber</div>
    <table class="detail-table">
      <tr>
        <td class="detail-label">Dokument id</td>
        <td>{{ dokument.id }}</td>
      </tr>
      <tr>
        <td class="detail-label">Dato</td>
        <td>
          {{ dokument.oprettelsesTidspunkt | date: 'dd-MM-yyyy HH:mm:ss' }}
        </td>
      </tr>
      <tr>
        <td class="detail-label">Skabelon</td>
        <td>
          {{ dokument.dokumentType?.navn }}
          {{ dokument.dokumentType?.beskrivelse }}
        </td>
      </tr>
      <tr>
        <td class="detail-label">Navn</td>
        <td>{{ dokument.beskrivelse }}</td>
      </tr>
      <tr>
        <td class="detail-label">Størrelse</td>
        <td>{{ dokument.stoerrelse }} kb</td>
      </tr>
      <tr>
        <td class="detail-label">Kilde</td>
        <td>System</td>
      </tr>
      <tr>
        <td class="detail-label">Eksternt ID</td>
        <td>{{ dokument.eksterntId }}</td>
      </tr>
      <tr>
        <td class="detail-label">Synlig for</td>
        <td>{{ dokument.synlighed?.join(', ') }}</td>
      </tr>
      <tr>
        <td class="detail-label">CPR</td>
        <td>{{ dokument.cprNummer | cprNummer }}</td>
      </tr>
      <tr>
        <td class="detail-label">Regnr</td>
        <td>{{ dokument.regnr }}</td>
      </tr>
    </table>
    <div class="flex gap-2">
      <p-button label="Vis dokument" icon="pi pi-eye" (click)="onClickShow()" />
      <p-button
        label="Download dokument"
        icon="pi pi-download"
        outlined
        (click)="onClickDownload()" />
    </div>

    @if (dokument.dokumentSignering) {
      <div class="detail-section-header">Signering</div>
      <div class="font-semibold mt-2">Status</div>
      <div class="mt-4">
        @if (dokument.dokumentSignering.ebevisModtaget) {
          E-bevis modtaget
          {{
            dokument.dokumentSignering.ebevisModtaget
              | date: 'dd-MM-yyyy HH:mm:ss'
          }}
        } @else {
          E-bevis ikke modtaget
        }
      </div>
      @for (h of signeringHistorik(); track $index) {
        <div class="mt-4">{{ h }}</div>
      }

      @if (skalUnderskrives(dokument.dokumentSignering)) {
        <div class="font-semibold mt-6">Underskrifter</div>
        @for (
          p of dokument.dokumentSignering.dokumentSigneringParter;
          track $index
        ) {
          <div class="mt-4">{{ getUnderskriftStatus(p) }}</div>
        }
      }

      <div class="font-semibold mt-4">Bilag</div>
      @for (dok of bilag(); track dok.id) {
        <div class="mt-2">
          <a class="cursor-pointer" (click)="clickBilag(dok)">{{ dok.emne }}</a>
        </div>
      }
    }
  }
</p-scroll-panel>
